import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  inputWrapper: {
    display: 'flex',
    marginBottom: 20
  },
  input: {
    color: colour.grey[200],
    fontSize: 19,
    fontWeight: 600,
    textAlign: 'center',
    height: 44,
    border: 0,
    borderTop: `1px solid ${colour.grey[500]}`,
    borderBottom: `1px solid ${colour.grey[500]}`,
    maxWidth: 50
  },
  increment: {
    color: colour.grey[200],
    background: colour.grey[600],
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: '0 10px 10px 0',
    height: 44,
    width: 44,
    ':after': {
      content: '"+"',
      fontSize: 29,
      fontWeight: 600
    }
  },
  decrement: {
    color: colour.grey[200],
    background: colour.grey[600],
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: '10px 0 0 10px',
    height: 44,
    width: 44,
    position: 'relative',
    ':after': {
      content: '"-"',
      fontSize: 40,
      fontWeight: 600,
      position: 'absolute',
      top: -7,
      left: 0,
      width: '100%',
      textAlign: 'center'
    }
  },
  greyed: {
    color: colour.grey[500],
    background: '#ffffff',
    border: `1px solid ${colour.grey[500]}`
  }
});
